import React, { useState, useEffect } from "react"
import { getCalcoloTassa } from "../../services/endpoints";
import { showProgress, moveFocusTo } from "../../utils/elements";
import { isNotEmpty } from "../../utils/utilities";
import {
  Container,
  Row,
  Col,
  Button,
} from 'design-react-kit';

export const SibaMostraCalcolo = (props) => {

  const [isLoading, setLoading] = useState(true);
  const [calcolo, setCalcolo] = useState({});

  useEffect(() => {
    const loadCalcolo = async (scadenza, validita) => {
      const responseCalcoloTassa = await getCalcoloTassa(props.veicolo.idVeicolo, scadenza, validita)
      console.log("responseCalcoloTassa=", responseCalcoloTassa);
      if (responseCalcoloTassa === undefined) {
        console.log('Calcolo fallito per veicolo %s', props.veicolo.idVeicolo)
        setLoading(false)
        return
      }
      props.handleDataLoaded(responseCalcoloTassa)
      setCalcolo(responseCalcoloTassa)
      setLoading(false)
    }

    if (isNotEmpty(props.scadenzaForzata)) {
      console.log('SCADENZA FORZATA')
      loadCalcolo(props.scadenzaForzata, props.validitaForzata)
    } else if (props.situazionePagamento.isPagabile === true) {
      console.log('PAGABILE')
      loadCalcolo(props.situazionePagamento.scadenza, props.situazionePagamento.validita)
    }
    //else ERRORE!
  }, []);

  useEffect(() => {
    moveFocusTo("conferma_calcolo");
  });

  const onSubmit = () => props.handleNext()
  const getTotale = (calcolo) => { return (calcolo.importo.tassa.importo + calcolo.importo.sanzioni.importo + calcolo.importo.interessi.importo).toFixed(2); }
  const isCalcoloConSanzioni = (calcolo) => { return (calcolo.importo.sanzioni.importo.toFixed(2) !== 0.00) }

  //START RENDERING
  if (isLoading) { return showProgress() }

  return (
    <Container className="px-2 my-2" id="mostraCalcolo" tag="section">
      <Row>
        <Col>
          <h4>Riepilogo dati calcolo</h4>
          <table className="table table-striped table-sm">
            <tbody>
              <tr>
                <th>Targa</th>
                <td>{props.veicolo.targa}</td>
              </tr>
              <tr>
                <th>Destinazione veicolo</th>
                <td>{calcolo.esitoCalcoloRegionale.destinazioneVeicolo.descrizione}</td>
              </tr>
              <tr>
                <th>Bollo valido fino a</th>
                <td>{calcolo.dataScadenza.mese.descrizione} {calcolo.dataScadenza.anno}</td>
              </tr>
              <tr>
                <th>Validit&agrave;</th>
                <td>{calcolo.validita} mesi</td>
              </tr>
              <tr>
                <th>Importo</th>
                <td><strong>{calcolo.importo.tassa.importo.toFixed(2)}</strong> {calcolo.importo.tassa.divisa.descrizione}</td>
              </tr>
              {isCalcoloConSanzioni(calcolo) ? (
                <>
                  <tr>
                    <th>Tipo sanzionamento</th>
                    <td>{calcolo.esitoCalcoloRegionale.tipoSanzionamento.descrizione}</td>
                  </tr>
                  <tr>
                    <th>Sanzioni</th>
                    <td><strong>{calcolo.importo.sanzioni.importo.toFixed(2)}</strong> {calcolo.importo.tassa.divisa.descrizione}</td>
                  </tr>
                  <tr>
                    <th>Interessi</th>
                    <td><strong>{calcolo.importo.interessi.importo.toFixed(2)}</strong> {calcolo.importo.tassa.divisa.descrizione}</td>
                  </tr>
                  <tr>
                    <th>Totale</th>
                    <td><strong>{getTotale(calcolo)}</strong> {calcolo.importo.tassa.divisa.descrizione}</td>
                  </tr>
                </>
              ) : React.Fragment
              }
              <tr>
                <th>Parametri calcolo</th>
                <td>{calcolo.esplicativo}</td>
              </tr>
              <tr>
                <th>Ultimo giorno utile per pagamento senza sanzioni</th>
                <td>{calcolo.esitoCalcoloRegionale.ultimoGiornoUtileProrogato}</td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
      <Button id="conferma_calcolo" className="btn btn-primary" color="primary" size="sm" icon={false} tag="button" onClick={onSubmit} >
        {/* STALIGK-834 Procedi al pagamento */}Avanti
      </Button>
    </Container>
  )
}

export default SibaMostraCalcolo;